import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTramite } from "../context/Tramite";
import "./css/components.css";
import { buscarUnidad, listarFrecuenciasRetiros } from "../api/General";
import { useCatalog } from "../context/Catalog";
import { crearTratamientoExterno, withResiduosPeligrosos } from "../utils/data";
import { isInvalid } from "../utils/forms";
import { isEditable } from "../utils/tramite";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import ArrayField from "./controls/ArrayField";
import { TratamientoExternoForm } from "./TratamientoExternoForm";
import { TratamientoExternoList } from "./TratamientoExternoList";
import { TipoTramite } from "../utils/enums";

export default function TratamientosExternosForm({ ...props }) {
  const { tramite } = useTramite();
  const { t } = useTranslation();
  const tramiteForm = useFormikContext();
  const unidadCaudalAnualCatalog = useCatalog(["unidad", "M3ANIO"], () =>
    buscarUnidad("M3ANIO"),
  );
  const frecuenciasRetiroCatalog = useCatalog(
    ["frecuenciasRetiros"],
    () => listarFrecuenciasRetiros(null),
  );
  const loading =
    unidadCaudalAnualCatalog.loading || frecuenciasRetiroCatalog.loading;
  const handleTratamientosExternosChange = (event) => {
    tramiteForm.handleChange(event);
  };
  useEffect(() => {
    if (
      !tramiteForm.values.conResiduosPeligrosos &&
      tramiteForm.values.tipo?.codigo === TipoTramite.DJG
    ) {
      const conPeligrosidad =
        tramiteForm.values.tratamientosExternos?.filter(
          (tratamientoExterno) => tratamientoExterno.conPeligrosidad,
        ).length > 0;
      if (conPeligrosidad) {
        withResiduosPeligrosos(tramiteForm, true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tramiteForm.values.tratamientosExternos]);
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col lg={12}>
            <ArrayField
              id="tratamientosExternos"
              name="tratamientosExternos"
              label={t("tramite.tratamientosExternos")}
              value={tramiteForm.values.tratamientosExternos}
              onChange={handleTratamientosExternosChange}
              createItem={crearTratamientoExterno}
              isInvalid={isInvalid("tratamientosExternos", tramiteForm)}
              error={
                (tramiteForm.errors.tratamientosExternos instanceof Array &&
                  t("errors.tramite.tratamientosExternos.many")) ||
                t(tramiteForm.errors.tratamientosExternos)
              }
              disabled={!isEditable(tramite)}
            >
              {({
                value: tratamientosExternos,
                append,
                remove,
                replace,
                select,
                selectedIndex,
                selectedItem,
                disabled,
              }) => (
                <Grid>
                  {!disabled && (
                    <Row>
                      <Col>
                        <TratamientoExternoForm
                          value={selectedItem}
                          page={selectedIndex}
                          pages={tratamientosExternos.length}
                          select={select}
                          append={append}
                          replace={replace}
                          remove={remove}
                          tramiteForm={tramiteForm}
                          frecuenciasRetiro={frecuenciasRetiroCatalog.data}
                          unidadCaudalAnual={unidadCaudalAnualCatalog.data}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <TratamientoExternoList
                        value={tratamientosExternos}
                        select={select}
                        remove={remove}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ArrayField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
